/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationCheck
 */
export interface NotificationCheck {
    /**
     * Number of new notifications
     * @type {number}
     * @memberof NotificationCheck
     */
    count: number;
}

/**
 * Check if a given object implements the NotificationCheck interface.
 */
export function instanceOfNotificationCheck(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function NotificationCheckFromJSON(json: any): NotificationCheck {
    return NotificationCheckFromJSONTyped(json, false);
}

export function NotificationCheckFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationCheck {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
    };
}

export function NotificationCheckToJSON(value?: NotificationCheck | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
    };
}

